import {
  MealProps,
  GET_MEALS,
  SET_MEALS,
  PLACE_ORDER,
  MealOrderProps,
  ADD_MEAL,
  EDIT_MEAL,
  EditMeal,
  AddMeal,
  GET_MYMEALS,
  SET_MEAL_VISIBILITY,
  MealVisibilityProps,
  DeleteMealProps,
  DELETE_MEAL,
  SET_LAST_MEAL,
  GET_MORE_MEALS,
} from './types';

export const getMeals = () => ({ type: GET_MEALS });

export const getMyMeals = () => ({ type: GET_MYMEALS });

export const setMeals = (meals: MealProps[]) => ({ type: SET_MEALS, meals });

export const addMeal = (meal: AddMeal) => ({ type: ADD_MEAL, meal });

export const MealEdit = (meal: EditMeal) => ({ type: EDIT_MEAL, meal });

export const getMoreMeals = () => ({ type: GET_MORE_MEALS });

export const setLastMealField = (lastMealField: object) => ({
  type: SET_LAST_MEAL,
  lastMealField,
});

export const deleteMeal = (meal: DeleteMealProps) => ({
  type: DELETE_MEAL,
  meal,
});

export const setMealVisibility = (meal: MealVisibilityProps) => ({
  type: SET_MEAL_VISIBILITY,
  meal,
});

export const placeOrder = (order: MealOrderProps) => ({
  type: PLACE_ORDER,
  order,
});
